import { memo } from 'react';
import { Pressable, type LayoutChangeEvent } from 'react-native';

import { Text } from '@/components/ui';
import { createStyles } from '@/hooks';
import { colors, guardianColors, withOpacity } from '@/theme/colors';

type NotificationChipProps = {
  active: boolean;
  label: string;
  onLayout?: (event: LayoutChangeEvent) => void;
  onPress: () => void;
};

export const NotificationChip = memo(function NotificationChip({
  active,
  label,
  onLayout,
  onPress,
}: NotificationChipProps) {
  const styles = useStyles();

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityState={{ selected: active }}
      onLayout={onLayout}
      onPress={onPress}
      style={[styles.chip, active ? styles.active : styles.inactive]}>
      <Text
        variant="Font Guardian App/Subtitle/Subtitle 12 Regular"
        style={active ? styles.activeText : styles.text}>
        {label}
      </Text>
    </Pressable>
  );
});

const useStyles = createStyles(({ scale }) => ({
  chip: {
    height: scale(32),
    paddingHorizontal: scale(16),
    borderRadius: scale(40),
    alignItems: 'center',
    justifyContent: 'center',
  },
  active: { backgroundColor: guardianColors['Main/Main'] },
  inactive: {
    backgroundColor: withOpacity(colors['0'], 0.6),
    borderWidth: 1,
    borderColor: guardianColors['2'],
  },
  activeText: { color: colors['0'] },
  text: { color: colors['10'] },
}));
